import BondsAssetPositionDetails from './bonds-asset-position-details';

import assetPositionsFactory from '../positions/asset-positions-factory';

export default assetPositionsFactory({
  assetCategory: 'bonds',
  ExpandedRowComponent: BondsAssetPositionDetails,
});
